module.exports = __webpack_public_path__ + "static/media/logo-dark.e61a8243.png";